var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.766 13.875c.063.058.128.11.189.17l5 5a6.3 6.3 0 0 1-8.91 8.91l-5-5a6.286 6.286 0 0 1 2.969-10.568 3.279 3.279 0 0 1 .553.905 5.288 5.288 0 0 0-2.815 8.956l5 5a5.3 5.3 0 0 0 7.496-7.496l-4.488-4.488a8.366 8.366 0 0 0 .006-1.389zm-12.526 3.86l-4.488-4.487a5.3 5.3 0 0 1 7.496-7.496l5 5a5.288 5.288 0 0 1-2.815 8.956 3.278 3.278 0 0 0 .553.905 6.287 6.287 0 0 0 2.969-10.568l-5-5a6.3 6.3 0 0 0-8.91 8.91l5 5c.061.06.126.112.189.17a8.367 8.367 0 0 1 .006-1.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink32);
export default __webpack_public_path__ + "static/media/link-32.5ee3e3a52bd24527421edce784ea7688.svg";
export { ForwardRef as ReactComponent };